export type Suit = 'man' | 'pin' | 'sou';
export type Wind = 'east' | 'south' | 'west' | 'north';
export type Dragon = 'white' | 'green' | 'red';

export type TileType = Suit | 'wind' | 'dragon';
export type TileValue = number | Wind | Dragon;

export interface Tile {
    /** Unique identifier for the tile instance (e.g., "man-1-0") */
    id: string;
    /** The category of the tile */
    type: TileType;
    /** The numeric value (1-9) or specific honor value */
    value: TileValue;
    /** Whether this tile is a red dora */
    isRed: boolean;
}

export const SUITS: Suit[] = ['man', 'pin', 'sou'];
export const WINDS: Wind[] = ['east', 'south', 'west', 'north'];
export const DRAGONS: Dragon[] = ['white', 'green', 'red'];

/**
 * Generates a full set of 136 Mahjong tiles.
 * Includes Red Doras (Akadora) by default: 1 per 5-value suit tile.
 */
export function generateWall(): Tile[] {
    const tiles: Tile[] = [];

    // Generate Suit Tiles
    SUITS.forEach((suit) => {
        for (let val = 1; val <= 9; val++) {
            for (let copy = 0; copy < 4; copy++) {
                // Standard rule: One red 5 per suit.
                // We'll mark the first copy (index 0) of any 5 as red.
                const isRed = val === 5 && copy === 0;

                tiles.push({
                    id: `${suit}-${val}-${copy}`,
                    type: suit,
                    value: val,
                    isRed,
                });
            }
        }
    });

    // Generate Wind Tiles
    WINDS.forEach((wind) => {
        for (let copy = 0; copy < 4; copy++) {
            tiles.push({
                id: `wind-${wind}-${copy}`,
                type: 'wind',
                value: wind,
                isRed: false,
            });
        }
    });

    // Generate Dragon Tiles
    DRAGONS.forEach((dragon) => {
        for (let copy = 0; copy < 4; copy++) {
            tiles.push({
                id: `dragon-${dragon}-${copy}`,
                type: 'dragon',
                value: dragon,
                isRed: false,
            });
        }
    });

    return tiles;
}

/**
 * Shuffles an array of tiles (Fisher-Yates shuffle).
 */
export function shuffleWall(tiles: Tile[]): Tile[] {
    const shuffled = [...tiles];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
}
